import React from "react";
import styles from "./onePlusnPlusnSet.scss";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Icons } from "../assests/icons";
import SetOneNNBundleProduct from "../setOneNNBundleProduct/setOneNNBundleProduct";

const ExpandMoreIcon = () => {
  return (
    <div>
      <svg
        width="16"
        height="10"
        viewBox="0 0 16 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0.499999C7.88311 0.499999 7.7779 0.535572 7.68439 0.606718L0.355204 8.07707C0.285068 8.14822 0.25 8.24308 0.25 8.36166C0.25 8.48024 0.285068 8.58695 0.355204 8.68182L1.05656 9.39328C1.1267 9.46443 1.22021 9.5 1.3371 9.5C1.454 9.5 1.5592 9.46443 1.65271 9.39328L8 2.95454L14.3473 9.39328C14.4408 9.46443 14.546 9.5 14.6629 9.5C14.7798 9.5 14.8733 9.46443 14.9434 9.39328L15.6448 8.68182C15.7149 8.58696 15.75 8.48024 15.75 8.36166C15.75 8.24308 15.7149 8.14822 15.6448 8.07708L8.28054 0.606718C8.21041 0.535572 8.11689 0.499999 8 0.499999Z"
          fill="#2C2C2C"
        />
      </svg>
    </div>
  );
};
const ListTag = ({ title, backgroundColor, textColor }) => {
  return (
    <div className={styles["tag"]} style={{
      backgroundColor,
      color: textColor ?? '#396e75',
    }}>
      {title || '精選商品'}
    </div>
  )
}
const OnePlusnPlusnSet = (props) => {
  const {
    defaultItem,
    bundleItems,
    quantities,
    onItemQuantityChange,
    proportion,
    expanded,
    setExpanded,
    setNum,
    loadingProduct,
    promotionDetails,
    template
  } = props;
  const selectedProportion = bundleItems.reduce(
    (total, item) => total + (quantities[`${item.groupId}-${item.itemCode}`] || 0),
    0
  );
  const warningMessage = promotionDetails?.warningMessage?.replace(/N/ig, proportion - selectedProportion)
  const isProportionMatched = selectedProportion == proportion;




  const handleExpand = (e, value) => {
    setExpanded(value);
  };
  return (
    <div className={styles["container"]}>
      <Accordion
        classes={{
          root: styles["accordion"],
        }}
        expanded={expanded}
        onChange={handleExpand}
      >
        <AccordionSummary
          expandIcon={
            <div className={styles[expanded ? 'inTheDirection' : 'underTheDirection']}>
              <ExpandMoreIcon />
            </div>}
          classes={{
            root: styles["header-wrapper"],
            expandIconWrapper: styles["expand-icon"],
            expanded: styles["expanded"],
            content: styles["header"],
          }}
        // aria-controls="panel1a-content"
        // id="-header"
        >
          <span className={styles["title"]}>
            第 {setNum} 組：您可選擇 {proportion} 件商品：
            <span className={styles["proportion"]}>
              {selectedProportion} / {proportion}
            </span>
          </span>
          {!isProportionMatched && (
            <div className={styles["warning"]}>
              <span className={styles["icon"]}>{Icons.warning}</span>
              <span className={styles["text"]} style={{ color: promotionDetails?.warningMessageColor }}>
                {
                  warningMessage || `剩餘 ${proportion - selectedProportion} 個選項`
                }
              </span>
            </div>
          )}
        </AccordionSummary>
        <AccordionDetails
          classes={{
            root: styles["products"],
          }}
        >
          {/* <div className={styles["products"]}> */}
          <SetOneNNBundleProduct isDefault product={defaultItem} promotionDetails={promotionDetails} />
          {
            promotionDetails?.zones.map((item) =>
              <>
                <ListTag title={item.title} backgroundColor={item.backgroundColor} textColor={promotionDetails?.defaultTagColor} />
                {item.products?.map((bundleItem) => (
                  <SetOneNNBundleProduct
                    key={bundleItem.itemCode}
                    product={bundleItem}
                    proportion={item?.proportion}
                    groupId={item?.groupId}
                    relateSkus={item?.relateSkus}
                    quantity={quantities[`${bundleItem.groupId}-${bundleItem.itemCode}`]}
                    onItemQuantityChange={onItemQuantityChange}
                    disableButtons={bundleItem.disableAddToCollection}
                    loadingProduct={loadingProduct}
                    promotionDetails={promotionDetails}
                    template={template}
                    quantities={quantities}
                    productsLength={item.products.length}
                  />
                ))}
              </>
            )
          }
          {/* </div> */}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default OnePlusnPlusnSet;
